import {Grid} from '@primer/react-brand'

import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'

import type {GenericContent, GenericGroup, GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

import {FeaturesRiver} from '../_sections/FeaturesSection/FeaturesRiver'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function FeaturesSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro} = contentfulContent.fields
  const {featuresCopilotAiCodeEditorFeaturesRivers} = contentfulContent.ids as {
    featuresCopilotAiCodeEditorFeaturesRivers: GenericGroup
  }

  return (
    <Grid as="section" className="lp-Section pt-5 pt-lg-8 pb-8 lp-Resources-container border-bottom-0">
      <Grid.Column span={12}>
        {sectionIntro ? (
          <ContentfulSectionIntro component={sectionIntro} fullWidth headingSize="3" className="mb-6" />
        ) : null}

        {featuresCopilotAiCodeEditorFeaturesRivers && featuresCopilotAiCodeEditorFeaturesRivers.fields.content ? (
          <>
            {(featuresCopilotAiCodeEditorFeaturesRivers.fields.content as GenericContent[]).map(riverItem => (
              <FeaturesRiver key={riverItem.sys.id} river={riverItem} />
            ))}
          </>
        ) : null}
      </Grid.Column>
    </Grid>
  )
}

try{ FeaturesSection.displayName ||= 'FeaturesSection' } catch {}